$(function () {
  const btn = document.querySelector("button.hamburger");
  const rightmenu = document.querySelector('#rightmenu');

  if (!btn || !rightmenu) return;

  btn.addEventListener("click", () => {
    btn.classList.toggle("is-active");

    rightmenu.classList.toggle('is-open');
  });
});
